export const en = {
    // ─── Navigation (Sidebar) ───────────────────────────────
    navDashboard: 'Dashboard',
    navTransactions: 'Transactions',
    navStatistics: 'Statistics',
    navReports: 'Summary',
    navReportsHint: 'Analytics charts & statement export',
    navBudget: 'Budget',
    navSettings: 'Settings',

    // ─── Common ─────────────────────────────────────────────
    income: 'Income',
    expense: 'Expense',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    reset: 'Reset',
    export: 'Export',
    loading: 'Loading…',
    saving: 'Saving…',
    error: 'An error occurred',
    saveSuccess: 'Transaction saved successfully',
    updateSuccess: 'Transaction updated successfully',
    deleteSuccess: 'Transaction deleted successfully',
    saveFailed: 'Failed to save transaction',
    deleteFailed: 'Failed to delete transaction',
    invalidAmount: 'Please enter a valid amount greater than 0',
    storageMode: 'Storage mode',
    storageDesktop: 'Desktop app (SQLite)',
    storageBrowser: 'Web browser (localStorage)',
    noData: 'No data to display',
    period: 'This period',
    allTypes: 'All Types',
    allCategories: 'All Categories',
    confirmDelete: 'Are you sure you want to delete this transaction?',

    // ─── Dashboard ──────────────────────────────────────────
    dashboardTitle: 'Dashboard',
    dashboardSubtitle: 'Your financial overview at a glance',
    totalIncome: 'Total Income',
    totalExpense: 'Total Expense',
    netBalance: 'Net Balance',
    recentTransactions: 'Recent Transactions',
    lastEntries: 'Last {n} entries',
    noTransactionsYet: 'No transactions yet',
    addFirstTransaction: 'Add your first transaction to get started',

    // ─── Transactions ────────────────────────────────────────
    transactionsTitle: 'Transactions',
    totalRecords: '{n} total records',
    newTransaction: '+ New Transaction',
    editTransaction: 'Edit Transaction',
    addTransactionBtn: 'Add Transaction',
    updateBtn: 'Update',
    cancelEdit: 'Cancel Edit',
    formType: 'Type',
    formAmount: 'Amount',
    formCategory: 'Category',
    formDate: 'Date',
    formDescription: 'Description (optional)',
    formDescPlaceholder: 'Add a note…',
    formCategoryPlaceholder: 'e.g., Food, Transport',
    filters: 'Filters',
    filterSearch: 'Search',
    filterSearchPlaceholder: 'Category or note…',
    filterType: 'Type',
    filterCategory: 'Category',
    filterFrom: 'From',
    filterTo: 'To',
    showingOf: 'Showing {shown} of {total} transactions',
    noResults: 'No results found',
    noResultsHint: 'Try adjusting your filters',

    // ─── Scan Slip ───────────────────────────────────────────
    scanSlip: 'Scan Slip',
    scanBill: 'Scan Bill',
    scanBillHint: 'AI will read every item and categorize them automatically',
    scanSlipTitle: 'Scan Receipt / Slip',
    scanSlipDesc: 'Take a photo or upload a slip to auto-fill transaction data',
    scanSlipUpload: 'Upload Image',
    scanSlipCamera: 'Take Photo',
    scanSlipScan: 'Scan Slip',
    scanSlipProcessing: 'Reading text…',
    scanSlipSuccess: 'Scan completed — review and save',
    scanSlipFailed: 'Could not read all data — fill in manually',
    scanSlipNoImage: 'Please select an image first',
    scanSlipTapToSelect: 'Tap to select a slip image',
    scanSlipFormats: 'Supports JPG, PNG, HEIC and camera photos',
    scanSlipPreviewTitle: 'Review & adjust before saving',
    scanSlipUse: 'Use this data',

    // ─── Statistics ──────────────────────────────────────────
    statisticsTitle: 'Statistics',
    statisticsSubtitle: 'Charts and analytics for your finances',
    monthlyTrend: 'Monthly Trend',
    incomeVsExpense: 'Income vs Expense',
    expensesByCategory: 'Expenses by Category',
    incomeByCategory: 'Income by Category',
    summaryByCategory: 'Summary by Category',

    // ─── Reports ─────────────────────────────────────────────
    reportsTitle: 'Financial Summary & Reports',
    reportsSubtitle: 'Financial reports and analytics overview',
    reportsDesc: 'Comprehensive analytics charts, balance sheet, and financial statements',
    customizeStatementBtn: '⚙️ Customize Statement / Export',
    exportBtn: '↓ Export',
    subtabAnalytics: 'Analytics & Breakdown',
    subtabFinancials: 'Balance Sheet & Ledger',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    labelMonth: 'Month',
    labelQuarter: 'Quarter',
    labelYear: 'Year',
    exportReport: 'Export',
    categoryBreakdown: 'Category Breakdown',
    noDataPeriod: 'No data for this period',
    q1: 'Q1 (Jan–Mar)',
    q2: 'Q2 (Apr–Jun)',
    q3: 'Q3 (Jul–Sep)',
    q4: 'Q4 (Oct–Dec)',
    txCount: 'Transaction Count',
    expenseVsIncome: 'Expense vs Income by Category',
    clickRowDetails: 'Click row for details',
    items: 'items',
    showTable: 'Show All Transactions',
    hideTable: 'Hide Table',
    allTransactionsThisPeriod: 'All Transactions in This Period',
    exportSuccess: 'Export successful',
    exportFailed: 'Export failed',

    // ─── Budget ──────────────────────────────────────────────
    budgetTitle: 'Budget',
    budgetSubtitle: 'Set and track spending limits by category',
    labelSelectMonth: 'Month',
    setBudget: 'Set Budget',
    setBudgetForm: 'Set Budget Limit',
    labelBudgetCategory: 'Category',
    labelBudgetLimit: 'Budget Limit (THB)',
    labelAlertAt: 'Alert at (%)',
    alertHint: 'Alert triggers when spending reaches {pct}% of the limit',
    setBudgetBtn: 'Set Budget',
    budgetStatus: 'Budget Status',
    statusExceeded: 'Over budget',
    statusWarning: 'Near limit',
    statusOnTrack: '✅ On Track',
    remaining: 'Remaining',
    alertAtLabel: 'Alert at',
    noBudgetsYet: 'No budgets set',
    noBudgetsHint: 'Click "+ Set Budget" to add your first limit',
    selectCategory: 'Select category',
    budgetTips: 'Tips',
    tip1: 'Set realistic limits based on past spending',
    tip2: 'Alert threshold helps catch overspending early',
    tip3: 'Review and adjust budgets monthly',
    tip4: '🟢 On track · 🟡 Warning · 🔴 Exceeded',
    deleteBudgetConfirm: 'Delete budget for {category}?',

    // ─── Settings ────────────────────────────────────────────
    settingsTitle: 'Settings',
    settingsSubtitle: 'Preferences and data management',
    appearance: 'Appearance',
    darkMode: 'Dark Mode',
    darkModeOn: 'Currently using dark theme',
    darkModeOff: 'Switch to dark theme',
    languageLabel: 'Language',
    languageCurrent: 'English',
    exportBackup: 'Export & Backup',
    exportExcelTitle: 'Export to Excel',
    exportExcelDesc: 'Download all transactions as an Excel spreadsheet',
    exportExcelBtn: 'Export Excel',
    backupTitle: 'Backup Database',
    backupDesc: 'Create a local backup copy of your database',
    backupBtn: 'Backup',
    restoreTitle: 'Restore Database',
    restoreDesc: 'Replace current data from a backup file',
    restoreBtn: 'Restore',
    restoreConfirm: 'This will replace current data. Continue?',
    databaseSection: 'Database',
    dbCurrentPath: 'Current database file',
    dbDefault: '(default)',
    dbCustom: '(custom)',
    dbChooseBtn: 'Choose Database File',
    dbChooseDesc: 'Select a .db file to use',
    dbResetBtn: 'Use Default Database',
    dbResetDesc: 'Go back to the app default database',
    dbRestartNote: 'Please restart the app to use the new database',
    aboutTitle: 'About',
    appName: 'MoneyMa',
    appTagline: 'Track your money without typing',
    // {v} = version from package.json, injected at build time — never hardcode it here
    appVersion: 'Version {v}',
    appStack: 'React · Capacitor · Supabase · Gemini',
    featuresTitle: 'Features',
    featureList: [
        'Slip & receipt scanning',
        'Dashboard overview',
        'Income & expense tracking',
        'Category budgets',
        'Charts & statistics',
        'Search & filter history',
        'Excel & PDF export',
        'Cross-device sync',
        'Thai-English & dark mode',
    ],

    // ─── Table Headers ───────────────────────────────────────
    viewCards: 'Cards',
    viewTable: 'Table',
    thDate: 'Date',
    thCategory: 'Category',
    thDescription: 'Description',
    thType: 'Type',
    thAmount: 'Amount',
    thActions: 'Actions',
    thIncome: 'Income',
    thExpense: 'Expense',
    thNet: 'Net',

    // ─── Authentication ──────────────────────────────────────
    loginTitle: 'Sign In',
    signInBtn: 'Sign In',
    signingIn: 'Signing in...',
    registerTitle: 'Sign Up',
    signUpBtn: 'Sign Up',
    signingUp: 'Signing up...',
    emailLabel: 'Email Address',
    emailPlaceholder: 'your.email@example.com',
    passwordLabel: 'Password',
    passwordPlaceholder: '••••••••',
    passwordConfirmLabel: 'Confirm Password',
    passwordMinLength: 'Password must be at least 6 characters',
    passwordMatch: 'Passwords do not match',
    firstNameLabel: 'First Name',
    firstNamePlaceholder: 'John',
    lastNameLabel: 'Last Name',
    lastNamePlaceholder: 'Doe',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    noAccount: "Don't have an account?",
    haveAccount: 'Already have an account?',
    signUpHere: 'Sign up here',
    signInHere: 'Sign in here',
    continueGuest: 'Try Demo / Continue as Guest',
    demoMode: 'Or explore features without signing in',
    guestSubtitle: 'Data saved locally. You can sync to cloud anytime.',
    invalidEmail: 'Invalid email address',
    emailRequired: 'Please enter your email',
    passwordRequired: 'Please enter your password',
    firstNameRequired: 'Please enter your first name',
    lastNameRequired: 'Please enter your last name',
    loginFailed: 'Failed to sign in. Please check your credentials.',
    registerFailed: 'Failed to sign up.',
    signOutBtn: 'Sign Out',
    signInWithGoogle: 'Sign in with Google',
    signInWithApple: 'Sign in with Apple',
    orContinueWith: 'or continue with',

    // ─── Premium ─────────────────────────────────────────────
    premiumTitle: 'MoneyMa Premium',
    premiumBack: 'Back',
    oneTime: 'ONE-TIME',
    oneTimePrice: '$14.99',
    oneTimeSub: 'One-time payment, lifetime access',
    lifetime: 'Lifetime usage',
    freeUpdates: 'Free lifetime updates',
    localDevice: 'Save on device',
    backupRestore: 'Backup & Restore',
    subscription: 'SUBSCRIPTION',
    subPriceMonth: '$4.99/mo',
    subPriceYear: '$39.99/yr (Save 33%)',
    recommended: 'RECOMMENDED',
    onlineDb: 'Online database',
    cloudBackup: 'Cloud backup',
    support: 'Ongoing support',
    multiPlatform: 'Web, Mobile, Desktop support',
    whyUpgrade: 'Why upgrade to Premium?',
    benefit1: 'Unlimited accounts and categories',
    benefit2: 'AI scan bills & slips up to 1,500 times/month',
    benefit3: 'Auto sync and backup across devices',
    benefit4: 'Support development for future updates',
    additionalPayment: 'Additional Payment Channels',
    manualPaymentInfo: 'Transfer and send proof to our team to unlock',
    copy: 'Copy',
    copied: 'Copied!',
    contactUs: 'Contact Us',
    restorePurchases: 'Restore Purchases',
    premiumSuccess: '🎉 Congrats! You have been upgraded to Premium.',
    premiumStatus: 'You are already a Premium member',
    premiumStatusDesc: 'Thanks for supporting us! Enjoy all features without limits.',
    packageNotFound: 'No packages found. Please try again or contact support.',
    restoreSuccess: 'Restore successful! You are a Premium member.',
    restoreFailed: 'No Premium subscription found for this account.',
    loadingPackages: 'Loading packages...',
    buyNow: 'Subscribe {price}',
    downloadApp: 'Download on Google Play',
    testSystem: 'Test System',

    // ── i18n fix 5 Aug 2026: คีย์ที่โค้ดเรียกใช้แต่ยังไม่มีในไฟล์แปล ──
    userProfile: 'User Profile',
    notLoggedInProfile: 'Sign in to see your profile and AI quota',
    loginToSync: 'Sign in',
    aiUsageTitle: 'AI Scan Quota',
    quotaDaily: 'Daily',
    quotaMonthly: 'Monthly',
    quotaRemaining: 'Remaining',
    scanQuotaTitle: 'Free scan quota',
    scanQuotaLeft: '{n} of {max} left ({scope})',
    scanQuotaOut: 'Free scan quota used up — upgrade for unlimited scans',

    syncTitle: 'Cloud Sync',
    syncDesc: 'Upload and download your transaction data with the server',
    syncStatus: 'Sync status',
    syncNowBtn: 'Sync now',
    syncStateSyncing: 'syncing',
    syncStateFailed: 'failed',
    syncStateUpToDate: 'up to date',
    signInToSync: 'Sign in to sync',
    signInToSyncDesc: 'Your data stays on this device until you sign in',
    accountSection: 'Account',
    signOutDesc: 'Data is synced to the cloud before signing out.',
    signOutConfirm: 'Sign out? Your data will be synced to the cloud first.',

    // ── Account deletion (required by Google Play, in-app and on the web) ──
    deleteAccountTitle: 'Delete account permanently',
    deleteAccountDesc: 'Permanently remove your account and all data from our servers. This cannot be undone.',
    deleteAccountBtn: 'Delete account',
    deleteAccountWarning: 'Deleting your account permanently removes every transaction, budget, sync record, and subscription record. This cannot be undone.\n\nWe recommend exporting your data to Excel first.\n\nDo you want to continue?',
    deleteAccountConfirmPrompt: 'Type DELETE to confirm',
    deleteAccountConfirmWord: 'DELETE',
    deleteAccountMismatch: 'Confirmation text did not match. Deletion cancelled.',
    deleteAccountSubActive: 'This account has an active subscription. Deleting your account does not cancel billing — please cancel it from your Google Play subscriptions page first.',
    deleteAccountSuccess: 'Your account and all data have been permanently deleted.',
    deleteAccountFailed: 'Could not delete the account. Please try again or contact naiguitarfolk@gmail.com',
    deleteAccountDeleting: 'Deleting account...',

    // ── Promo banner (values come from src/config/promo.js) ──
    promoBannerTitle: 'Up to {pct}% off for new subscribers',
    promoBannerDaysLeft: '{n} days left',
    promoBannerLastDay: 'Last day',
    promoBannerAria: 'View limited offer details',

    // ── Paywall with 3 offers ──
    pwOffer_monthly: 'Monthly',
    pwOffer_yearly: '12 months',
    pwOffer_lifetime: 'One-time',
    pwBestValue: 'Best value',
    pwOneTime: 'Pay once',
    pwNoRenewal: 'Yours forever, no renewals',
    pwDiscountOff: '{pct}% off',
    pwFirstPeriodOnly: 'first month only',
    pwSubscribe: 'Subscribe',
    pwBuyOnce: 'Buy once',
    pwPremium: 'Premium',
    pwPromoTerms: 'The promotional price applies to your first billing period; it renews at the standard price. Cancel any time from your Google Play subscriptions page.',
    pwScansFree: '20 / month',
    pwHistory: 'History',
    pwHistory90: '90 days',
    pwBudget3: '3 categories',
    pwBudgetLimits: 'Category budgets',
    pwExport: 'Excel and PDF export',
    pwCloudSync: 'Cross-device sync',
    pwAutoScan: 'Auto-scan gallery',
    useCloudStorage: 'Use cloud storage',
    useCloudStorageDesc: 'Store data on the server instead of on this device only',

    resetPasswordTitle: 'Reset password',
    resetPasswordSubtitle: 'Choose a new password for your account',
    sendResetLink: 'Send reset link',
    resetLinkSent: 'Reset link sent. Please check your email.',
    newPasswordLabel: 'New password',
    updatePasswordBtn: 'Update password',
    grandTotal: 'Grand Total',
    total: 'Total',
    thPctExpense: '% of Expense',
    benefitsTitle: 'What you get',

    scanSlipCardDesc: 'Read a transfer slip',
    scanBillCardDesc: 'Split a receipt into items',
    freeQuotaTitle: 'Free plan transaction quota',
    freeQuotaUsed: 'Logged {n} of {max} entries this month',
    upgradeToPro: 'Upgrade to Pro',
    txLimitTitle: 'Free plan limit reached',
    txLimitDesc: 'The free plan allows up to <strong>50 transactions per month</strong>. Upgrade to Pro for unlimited entries and Cloud Sync.',
    budgetLimitTitle: 'Free plan budget limit reached',
    budgetLimitDesc: 'The free plan allows budgets for <strong>1 category</strong>. Upgrade to Pro to set unlimited budgets.',
    userLabel: 'User',

    // ── สแกนสลิป / สแกนบิล ──
    autoScanTitle: 'Auto-scan slips from your gallery',
    autoScanDesc: 'Pick several photos and AI reads and categorizes them for you',
    chooseSlipImage: 'Choose slip images',
    chooseNewImage: 'Choose another image',
    tapOrDrag: 'Tap to choose, or drag a file here',
    scanSlipHint: 'This takes a few seconds',
    scanSlipDuplicate: 'Already scanned',
    slipAlt: 'Transfer slip',
    billAlt: 'Receipt',
    dateTime: 'Date and time',
    sender: 'From',
    receiver: 'To',
    amount: 'Amount',
    refId: 'Reference number',
    ref2: 'Customer ref. 2',
    address: 'Address',
    slipNote: 'Note on the slip',
    editBeforeSave: 'Review before saving',
    note: 'Note',
    noteHint: 'Add more detail',
    retry: 'Try again',
    rescan: 'Scan again',
    saveItem: 'Save',
    batchScanning: 'Scanning',
    skipped: 'Skipped',
    errors: 'Failed',
    noSlipsFound: 'No slip found in the images you chose',
    found: 'Found',
    slips: 'slips',
    selectAll: 'Select all',

    billScanning: 'AI is reading the receipt…',
    billScanningHint: 'Identifying line items and categories',
    billStoreGeneric: 'Other store',
    billNotFound: 'No receipt data found in this image. Please try again',
    billGenericError: 'Something went wrong. Please try again',
    billPartialTitle: 'Partial read ({n} items)',
    billPartialDesc: 'This receipt has many lines and AI read only part of it. The total is calculated from what was read, so please check before saving.',
    billItemsTitle: 'Line items',
    billItemsHint: 'Tap to exclude · category is editable',
    billDiscount: 'Total discount',
    billTax: 'Tax',
    billGrandTotal: 'Total',
    billPaidWith: 'Paid with',
    billSaveAs: 'Save as',
    billSaveSingle: 'One combined entry',
    billSaveCategory: 'Split by category',
    billSaveItemized: 'One entry per item',
    billSummary: '{n} entries · {cur} {total}',
    localeTag: 'en-US',

    // ── Paywall / Upgrade / FeatureGate ──
    pwTitle: 'Upgrade MoneyMa',
    pwSubtitle: 'Unlock every feature: AI slip and bill scanning, and Cloud Sync',
    pwSubtitleFeature: 'Unlock {feature} and the rest of Pro',
    pwAriaLabel: 'Choose a plan',
    pwClose: 'Close',
    pwMonthly: 'Monthly',
    pwYearly: 'Yearly',
    pwSave: 'Save {pct}%',
    pwRecommended: 'Recommended',
    pwCurrent: 'Current',
    pwFree: 'Free',
    pwPerYear: 'year',
    pwPerMonth: 'month',
    pwMonthlyEquiv: '฿{n}/month',
    pwCompare: 'Feature comparison',
    pwProcessing: 'Processing…',
    pwCurrentPlanBtn: 'Current plan',
    pwUseFree: 'Use the free plan',
    pwStartPlan: 'Start {plan}',
    pwRestoring: 'Restoring…',
    pwRestore: 'Restore purchases',
    pwManageSub: 'Manage subscription',
    pwPaymentNote: 'Billed through {store} · cancel any time',
    pwNoPurchase: 'No saved purchase found',
    pwUnlimited: 'Unlimited',
    pwTxPerMonth: 'Transactions per month',
    pwTx50: '50 entries',
    pwAiScanSlip: 'AI slip scanning',
    pwAiScanBill: 'AI bill and receipt scanning',
    pwScansPerMonth: '200 scans/month',
    pwBudget1: '1 category',
    pwMultiWorkspace: 'Multiple workspaces',

    upgradeTitle: 'Unlock the full app',
    upgradeDesc: 'Upgrade for unlimited entries and cloud sync',
    upgradeCta: 'Upgrade to Pro',
    maybeLater: 'Maybe later',
    gotIt: 'Got it',
    featUnlimitedTx: 'Unlimited transactions, up from 50 a month',
    featCloudSync: 'Cloud Sync across your devices',
    featExcel: 'Unlimited Excel and PDF export',
    featUnlimitedBudgets: 'Budgets for every category, up from 1',
    featAlert: 'Alerts when you go over budget',
    featVisuals: 'Deeper charts and comparisons',

    fgAiScanSlip: 'AI slip scanning',
    fgAiScanBill: 'AI bill scanning',
    fgAutoScan: 'Auto-scan',
    fgUnlimitedTx: 'Unlimited transactions',
    fgMultiWorkspace: 'Multiple workspaces',
    fgAvailableIn: '{feature} is available in {plan}',
    fgOnlyIn: 'This feature is only available in {plan}',
    fgUpgradeTo: 'Upgrade to {plan}',
    fgUpgradeArrow: 'Upgrade',
    fgUnlock: 'Unlock {feature}',

    // ── ไฟล์ที่ส่งออก (PDF / CSV / TXT) ──
    expReportTitle: 'MoneyMa — Transaction report',
    expPeriod: 'Period',
    expGenerated: 'Generated',
    expOverview: 'Overview',
    expTotalIncome: 'Total income',
    expTotalExpense: 'Total expense',
    expNet: 'Net balance',
    expNegative: 'negative',
    expCount: 'Entries',
    expTransactions: 'Transactions',
    expColDate: 'Date',
    expColType: 'Type',
    expColCategory: 'Category',
    expColDescription: 'Description',
    expColAmount: 'Amount',
    expIncome: 'Income',
    expExpense: 'Expense',
    expTotal: 'Total',

    // ── ชื่อแพลนและป้าย ──
    planFree: 'Free',
    planPro: 'Pro',
    planBusiness: 'Business',
    planLifetime: 'Lifetime',
    badgeRecommended: 'Recommended',
    badgeOneTime: 'One-time',

    // ── ข้อผิดพลาดระบบชำระเงิน ──
    billNotConfigured: 'In-app billing is temporarily unavailable. Please try again later.',
    billNoOfferings: 'No packages available from App Store / Google Play yet. Please try again later.',
    billStoreError: 'Could not reach App Store / Google Play. Check your internet connection or Store login.',
    billInitFailed: 'Billing failed to start. Please try again',
    billNoPackages: 'No packages are available right now',
    billPackageNotFound: 'No package found for {plan} {period} (available: {list})',

    // ── ข้อผิดพลาดโควตา AI ──
    quotaDailyFull: 'You have used your free daily scans ({n} per day). Upgrade to keep scanning',
    quotaMonthlyFull: 'You have used all your scans ({n} per month)',
    quotaNeedLogin: 'Please sign in to use scanning',
    quotaCheckFailed: 'Could not check your AI quota',
    quotaBusy: 'AI capacity is full right now. Wait a moment and try again',
    scanNoSlip: 'No slip data found in this image. Please try again',
    scanGenericError: 'Something went wrong. Please try again',
    autoScanError: 'Auto-scan ran into a problem',
    aiSafetyBlocked: 'AI stopped because the image may contain unsafe content. Try a clearer photo',
    billLongWarn: 'Long receipt — read {n} items (may be incomplete)',
    billTooManyItems: 'This receipt has too many lines for AI to read in full ({n} items)\nTip: photograph it in two halves and scan each one',
    billNoJson: 'No JSON found in the AI response',
    billParseError: 'Could not read the bill data (JSON parse error): {msg}',
    billPaidBy: 'Paid with {method}',
    billItemCount: '{n} items',

    // ── หมวดสินค้าในบิล ──
    catFoodFresh: 'Fresh food',
    catFoodPackaged: 'Packaged food',
    catFoodSnack: 'Snacks and drinks',
    catHousehold: 'Household',
    catPersonalCare: 'Personal care',
    catHealth: 'Health and medicine',
    catAlcohol: 'Alcohol',
    catOther: 'Other',

    registerConfirmSent: 'A confirmation email has been sent. Please check your inbox and click the link to activate your account.',
    premiumHint: 'Upgrade to unlock additional features',

    // ─── Inventory & POS (Business) ───
    navInventory: 'Inventory & POS',
    navInventoryHint: 'Manage stock and issue invoices',
    posEyebrow: 'Business POS & Inventory',
    inventoryTitle: 'Inventory & POS Ledger',
    inventorySubtitle: 'Business POS & Inventory Management',
    tabInventory: '📦 Stock Inventory',
    tabPos: '🛒 Sales POS',
    tabPo: '🚚 Stock In / PO',
    businessTrialTitle: 'You have received a 7-Day Business Plan Free Trial',
    businessTrialDesc: 'Unlock multi-warehouse inventory, POS checkout, AI product scanning, and full document exports.',
    businessTrialDetailsBtn: '✨ Business Plan Details',
    gatePosTitle: '🔒 Inventory & POS System for Business Plan',
    gatePosDesc: 'Upgrade to Business Plan to enable full stock control, auto-deduction, tax invoice issuing, and POS billing.',
    tabPeriodicReport: '📊 Periodic Report',
    thermalPrinter: '🖨️ Receipt Printer (Thermal / Standard):',
    printerReady: 'Connected & Ready',
    autoPrintReceiptLabel: 'Auto-print receipt upon payment',
    testPrintBtn: '🧪 Test Print',
    totalProducts: 'Total Products',
    statTotalProducts: 'Total Products',
    statItemsCount: '{n} Items',
    statInStock: '{n} units in stock',
    statCostVal: 'Total Cost Value',
    statAllCost: 'Total Inventory Cost',
    statRetailVal: 'Total Retail Value',
    statEstProfit: 'Est. Profit ฿{val}',
    statLowStockAlert: 'Low Stock Alerts',
    statBelowMin: 'Below minimum threshold',
    itemsInStockHeader: 'Stock Inventory Items',
    btnAiCameraScan: 'Camera',
    btnAiFileScan: 'From file',
    aiScanningState: 'Scanning...',
    aiVisionModalHeader: 'Let AI fill in the details',
    prodImageLabel: 'Product photo',
    prodImageNone: 'No photo yet',
    prodImagePick: 'Choose / take photo',
    prodImageUrlHint: 'Or paste an image link',
    prodStockLegend: 'Stock on hand',
    prodStockTotal: 'Total',
    prodStockUnit: 'pcs',
    aiVisionModalSub: 'Capture camera photo or upload image file to autofill details',
    addNewProduct: '+ Add New Product',
    editProductTitle: 'Edit Product',
    addProductTitle: 'Add Product to Inventory',
    thSku: 'SKU Code',
    thProdName: 'Product Name',
    thCostPrice: 'Cost (THB)',
    thSellPrice: 'Price (THB)',
    thStockRemain: 'Stock Qty',
    thStatus: 'Status',
    thManage: 'Actions',
    statusOut: 'Out of Stock',
    statusLow: 'Low Stock',
    statusNormal: 'Normal',
    posSearchPlaceholder: '🔍 Search products by name or SKU...',
    cartTitle: '🛒 Shopping Cart',
    posCartEmpty: 'Your cart is empty. Click items on the left to add.',
    customerNameLabel: 'Customer / Company Name',
    taxIdLabel: 'Tax ID',
    supplierNameLabel: 'Supplier / Vendor Name',
    posSubtotal: 'Subtotal:',
    posDiscount: 'Discount (THB):',
    posVat: 'VAT (%):',
    posVatExempt: '0% (Non-VAT)',
    posVatIncluded: '7% (System VAT)',
    posGrandTotal: 'Net Total:',
    completeSaleBtn: '🧾 Complete Sale & Print Receipt',
    posSelectItemsToBuy: 'Select products to reorder into stock',
    poCartTitle: '🚚 Purchase Order (PO)',
    poEmpty: 'No items in purchase order. Click items on left to add.',
    poSupplierPlaceholder: 'Supplier / Vendor Name',
    poSupplierTaxIdPlaceholder: 'Supplier Tax ID',
    poUnitCost: 'Unit Cost: ฿',
    poUnitCostLabel: 'Unit cost',
    receiptImportTitle: 'Receipt from a shop',
    receiptImportLoading: 'Loading receipt…',
    receiptImportItems: '{n} item(s)',
    receiptImportSave: 'Save as expense',
    receiptImportClose: 'Close',
    receiptImportSaved: 'Saved as an expense',
    receiptImportAlready: 'This receipt is already saved',
    receiptImportNotFound: 'Receipt not found',
    receiptImportOffline: 'Couldn\'t connect. Try again.',
    receiptImportUnavailable: 'This receipt can\'t be opened yet. Try again later.',
    receiptImportRetry: 'Try again',
    receiptImportDesc: 'Receipt from {shop}',
    receiptImportUnknownShop: 'a shop',
    receiptImportHint: 'Saved under Shopping — you can edit it later.',
    poTotalExpense: 'Total Purchase (Expense):',
    completePoBtn: '📥 Receive Goods & Record Expense',
    prodModalMinStock: 'Alert below',

    // ─── Statement Builder ───
    customizeStatementDesc: 'Select columns, add logo/tax ID, and generate professional PDF/HTML statement reports',
    statementModalTitle: 'Customize Report Form & Statement',
    statementModalEyebrow: 'Export & Report Builder',
    docDetails: '1. Document & Header Details',
    exportFormat: 'Select Export Format',
    fmtPdf: '📄 Official Statement (PDF/Print)',
    fmtPdfDesc: 'Includes company logo, header, and running balance',
    fmtExcel: '📊 Excel File (.xlsx)',
    fmtExcelDesc: 'For further analysis in Excel or Spreadsheets',
    fmtCsv: '📁 CSV File (.csv)',
    fmtCsvDesc: 'Import into accounting software',
    fmtText: '📝 Plain Text (.txt)',
    fmtTextDesc: 'Compact text summary',
    docTitleLabel: 'Report / Document Title',
    companyNameLabel: 'Company / Organization Name',
    addressLabel: 'Address',
    phoneLabel: 'Phone',
    footerNoteLabel: 'Footer Disclaimer / Note',
    tableColumnsSection: '2. Select Table Columns',
    dateFilterSection: '3. Filter Date Range',
    colDate: 'Date',
    colType: 'Type',
    colCategory: 'Category',
    colDescription: 'Description',
    colAmount: 'Amount',
    colBalance: 'Running Balance',
    livePreviewTitle: '👀 Live Statement Preview',
    runExportBtn: '🚀 Print / Export File ({fmt})',
    defaultDocTitle: 'Financial Statement (Business Statement)',
    defaultCompanyName: 'MoneyMa Co., Ltd.',
    defaultAddress: '88/99 Financial Building, Sukhumvit Road, Bangkok 10110',
    defaultFooterNote: 'This statement is system generated by MoneyMa Financial System for business records.',
};
